/**
 * Users/Delete User Controller
 *
 * 
 */

// the constructor for this object
function UsersDeleteUserController() { }

// the object
UsersDeleteUserController.prototype = {
    constructor: UsersDeleteUserController,
    /*
        This is the User ID of the user we plan to delete. By default it's populated 
        from the routeSegments of the current page.
    */
    userToDelete: '',
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        this.userToDelete = PortalMain.getRouteSegments()[0];
        PortalHelper.debugMessage('Delete User Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // confirm the user has the proper permissions
        if (this._confirmPermission()) {
            
            // confirm that the user id is valid
            this._validateUserId();
        }
        PortalHelper.debugMessage('Delete User Controller Ran');
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        var self = this;
        $('.delete-btn').on("click", function(){
            self._deleteAccount();
        });
    },
    
    // see if the user has admin permissions
    _confirmPermission: function()
    {
        var portalUserAccounts = PortalMain.PortalAccounts.getAdminAccounts();
        
        /*
            If the user has no admin access to any customer accounts, they can't
            add users, so hide the whole form and display a message
        */
        if(portalUserAccounts.length == 0) {
            $('.delete-user-wrap').html('Your account does not have permission to delete users.');
            PortalHelper.loadingOverlay('.delete-user-wrap', false);
            return false;
        }
        
        return true;
    },
    
    /*
        Ensures that we have a valid user ID in the URL before making a request
        to delete a user.
    */
    _validateUserId: function()
    {
        if(this.userToDelete == undefined) {
            $('.delete-user-wrap').hide();
            $('.form-errors').html("User ID is invalid. Please try again.").removeClass('hidden');
            return;
        }
        var userRequest = new PortalRequest();
        userRequest.errorElement = '.form-errors';
        userRequest.makeRequest(
            '/users/get-user',
            {
                userId: this.userToDelete
            },
            function(response, code, message) {
                $('#user-name').html(response.email_nm);
                PortalHelper.loadingOverlay('.delete-user-wrap', false);
            },
            function() {
                $('.delete-user-wrap').hide();
                $('.form-errors').append('<br> Redirecting...');
                setTimeout(function () {
                    window.location.href = PortalConfig.portalUrl + '/users/';
                }, 3000);
                PortalHelper.loadingOverlay('.delete-user-wrap', false);
            }
        )
    },
    
    /*
        For a user (specified in the URL), removes access to any customer 
        accounts that the current user has administrator permissions on.
    */
    
    _deleteAccount: function()
    {
        PortalHelper.loadingOverlay('.delete-user-wrap', true);
        var self = this;
        var deleteRequest = new PortalRequest();
        deleteRequest.successElement = '.form-success';
        deleteRequest.errorElement = '.form-errors';
        deleteRequest.makeRequest(
            '/users/delete-user',
            {
                userId: this.userToDelete
            },
            self._redirectAfterDelete(),
        )
    },
    
    /*
        Redirects the user to the user management index page after an account 
        has been deleted.
    */
    
    _redirectAfterDelete: function()
    {
        $('.delete-user-wrap').addClass('hidden');
        setTimeout(function () {
            window.location.href = PortalConfig.portalUrl + '/users/';
        }, 3000);
    },
    
}